import { Icon } from '@iconify/react'

import s from './InsightSection.module.css'

type Props = {
  heading: string
  subHeading: string
  children: React.ReactNode
}

const InsightSection = ({ heading, subHeading, children }: Props) => {
  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className={s.sectionIcon}>
          <Icon icon="lucide:search" width={16} height={16} />
        </div>
        <h2 className={s.heading}>{heading}</h2>
        <p className={s.subHeading}>{subHeading}</p>
      </div>
      {children}
    </div>
  )
}

export default InsightSection
